export default __webpack_public_path__ + "static/media/dubai.c313008f.jpg";